import { Dispatch } from "redux";

import { VendorStateAction } from "@reducers/types/procurements/vendor-state";

import {
  GET_VENDORS,
  GET_VENDOR,
  CREATE_VENDOR,
  UPDATE_VENDOR,
  DELETE_VENDOR,
} from "./types";
import { VendorCreateType } from "@type/procurements/vendor";
import {
  fetchVendors,
  fetchVendorById,
  createVendor,
  updateVendor,
  deleteVendor,
} from "@api/procurements/vendor";

export const vendorFetchActionHandler =
  (query: any) => async (dispatch: Dispatch<VendorStateAction>) => {
    dispatch({ type: GET_VENDORS.LOADING, payload: true });

    try {
      const res = await fetchVendors(query);

      const { data, page, size, total } = res.data || {};

      dispatch({
        type: GET_VENDORS.SUCCESS,
        payload: {
          data,
          pagination: {
            page,
            size,
            total,
          },
        },
      });
    } catch (err) {
      dispatch({ type: GET_VENDORS.ERROR, payload: null });
    }
  };

export const vendorByIdFetchActionHandler =
  (id: string | number) => async (dispatch: Dispatch<VendorStateAction>) => {
    dispatch({ type: GET_VENDOR.LOADING, payload: true });

    try {
      const res = await fetchVendorById(id);

      dispatch({
        type: GET_VENDOR.SUCCESS,
        payload: res.data || {},
      });
    } catch (err) {
      dispatch({ type: GET_VENDOR.ERROR, payload: err });
    }
  };

export const vendorCreateActionHandler =
  (data: VendorCreateType) => async (dispatch: Dispatch<VendorStateAction>) => {
    dispatch({ type: CREATE_VENDOR.LOADING, payload: true });

    try {
      const res = await createVendor(data);

      dispatch({ type: CREATE_VENDOR.SUCCESS, payload: res.data });
    } catch (err) {
      dispatch({ type: CREATE_VENDOR.ERROR, payload: err });
    }
  };

export const vendorUpdateActionHandler =
  (id: string | number, data: VendorCreateType) =>
  async (dispatch: Dispatch<VendorStateAction>) => {
    dispatch({ type: UPDATE_VENDOR.LOADING, payload: true });

    try {
      const res = await updateVendor(id, data);

      dispatch({
        type: UPDATE_VENDOR.SUCCESS,
        payload: { id },
      });
    } catch (err) {
      dispatch({ type: UPDATE_VENDOR.ERROR, payload: false });
    }
  };

export const vendorDeleteActionHandler =
  (id: string | number) => async (dispatch: Dispatch<VendorStateAction>) => {
    dispatch({ type: DELETE_VENDOR.LOADING, payload: true });

    try {
      const res = await deleteVendor(id);

      dispatch({ type: DELETE_VENDOR.SUCCESS, payload: id });
    } catch (err) {
      dispatch({ type: DELETE_VENDOR.ERROR, payload: err });
    }
  };
